const state = {
    imgSampleConsultantProfile: process.env.BASE_URL+"images/user.png",
    imgSampleConsultantSquare: process.env.BASE_URL+"images/consultant_img.png",
    imgSampleConsultant: process.env.BASE_URL+"images/find-consultant.png",
    imgSampleShop: process.env.BASE_URL+"images/sample_11.png",
    imgSampleShopSquare: process.env.BASE_URL+"images/freebook_consultant.png",
    imgSampleBrand: process.env.BASE_URL+"images/Group.png",
    imgSampleDealer: process.env.BASE_URL+"images/dealer.png",
    imgSampleModel: process.env.BASE_URL+"images/sample.png",
    imgSampleTrim: process.env.BASE_URL+"images/model.png",
    imgSampleTrimSquare: process.env.BASE_URL+"images/car.png",
    imgSampleBanner: process.env.BASE_URL+"images/banner_img.png",
    imgSampleAttention: process.env.BASE_URL+"images/attention_img.png",
    imgSampleMainBanner: process.env.BASE_URL+"images/prebook_Main_image.png",
    
    imgIconArrowOpen: process.env.BASE_URL+"images/Vector.png",
    imgIconArrowRigth: process.env.BASE_URL+"images/arrow_right.png",
    imgIconArrowRigthSmall: process.env.BASE_URL+"images/right_arrow.png",
    imgIconNext: process.env.BASE_URL+"images/next.png",
    imgIconNext2: process.env.BASE_URL+"images/next1.png",
    imgIconUser: process.env.BASE_URL+"images/user_icon.png",
    imgIconGood: process.env.BASE_URL+"images/good.png",
    imgIconGood2: process.env.BASE_URL+"images/goodo.png",
    imgIconMessage: process.env.BASE_URL+"images/message.png",
    imgIconCertified: process.env.BASE_URL+"images/icon1.png",
    imgIconCertified2: process.env.BASE_URL+"images/icon2.png",
    imgIconCertified3: process.env.BASE_URL+"images/blue.png",

    imgIconKakao: process.env.BASE_URL+"images/kakao_icon1.png",
    imgIconGoogle: process.env.BASE_URL+"images/google_icon1.png",
    imgIconApple: process.env.BASE_URL+"images/apple_icon1.png",

    imgReviewGood: process.env.BASE_URL+"images/feel_good.png",
    imgReviewNormal: process.env.BASE_URL+"images/feel_soso.png",
    imgReviewBad: process.env.BASE_URL+"images/feel_bad.png",

    imgLogoBmw: process.env.BASE_URL+"images/bmw_logo.png",

    imgPreebookLogoW: process.env.BASE_URL+"images/prebook_w.png",
    
}

const getters = {

    viewModelAttUrl(state){
        return (url=null) => {  return (url) ? url : state.imgSampleModel ; }
    },

    viewTrimAttUrl(state){
        return (url=null) => {  return (url) ? url : state.imgSampleTrim ; }
    },

    viewTrimAtts(state){
        return (trim_atts) => {
            let atts = [{ id:'default', url: state.imgSampleTrim }];
            if(trim_atts && trim_atts.length > 0) atts = trim_atts;
            return atts;
        }
    },

    viewShopAttUrl(state){
        return (url=null) => {  return (url) ? url : state.imgSampleShop ; }
    },

    viewShopAtts(state){
        return (shop_atts) => { 
            let atts = [{ id:'default', url: state.imgSampleShop }];
            if(shop_atts && shop_atts.length > 0) atts = shop_atts;
            return atts;
        }
    },

    viewScAttUrl(state) {
        return (url=null) => { 
            return (url) ? url : state.imgSampleConsultantSquare ; }
    },

    // viewScAttUrl(){
    //     return (url=null) => {  return (url) ? url : state.imgSampleModel ; }
    // },

    viewDealerAtts(state) {
        return (dealer_atts) => {
            let atts = [{ id:'default', url: state.imgSampleDealer }];
            if(dealer_atts && dealer_atts.length > 0) atts = dealer_atts;
            return atts;
        }
    }
}
// resource.imgIconUser


export default { state, getters }